import { useLocation } from '@reach/router'
import PropTypes from 'prop-types'
import React from 'react'
import { Helmet } from 'react-helmet'

import {
  DEFAULT_DESCRIPTION,
  DEFAULT_IMAGE,
  DEFAULT_KEYWORDS,
  DEFAULT_SITE_CONTENT_TYPE,
  DEFAULT_SITE_NAME,
  DEFAULT_TITLE,
  SITE_URL,
  TWITTER_USERNAME,
} from '../../constants/seo'

function SEOControl({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  image = DEFAULT_IMAGE,
  type = DEFAULT_SITE_CONTENT_TYPE,
  schemaMarkup,
}) {
  const { pathname } = useLocation()

  const url = `${SITE_URL}${pathname}`

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="image" content={image} />

      <link rel="canonical" href={url} />

      <meta property="og:site_name" content={DEFAULT_SITE_NAME} />
      <meta property="og:url" content={SITE_URL} />
      {type && <meta property="og:type" content={type} />}

      {url && <meta property="og:url" content={url} />}

      {title && <meta property="og:title" content={title} />}

      {description && <meta property="og:description" content={description} />}

      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content="summary_large_image" />

      {TWITTER_USERNAME && (
        <meta name="twitter:creator" content={TWITTER_USERNAME} />
      )}

      {title && <meta name="twitter:title" content={title} />}

      {description && <meta name="twitter:description" content={description} />}

      {image && <meta name="twitter:image" content={image} />}
      {schemaMarkup && (
        <script type="application/ld+json">{schemaMarkup}</script>
      )}
    </Helmet>
  )
}

SEOControl.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  image: PropTypes.string,
  type: PropTypes.string,
}

export default SEOControl
